'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Chip = require('./Chip.js');
var index = require('./Icon/index.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const IconCheckMark = _ref => {
  let {
    ariaLabel
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "CheckMark",
    width: "11",
    height: "11",
    "aria-label": ariaLabel
  });
};
const IconAdd = _ref2 => {
  let {
    ariaLabel
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "Add",
    width: "11",
    height: "11",
    "aria-label": ariaLabel
  });
};
const ActionChipsContainer = styled__default["default"].div.withConfig({
  componentId: "sc-d67s25-0"
})(["display:flex;gap:0.5rem;flex-wrap:wrap;"]);
const ActionChip = _ref3 => {
  let {
    label,
    statusConfigs,
    isComplete,
    onClick
  } = _ref3;
  const incompleteIcon = statusConfigs.incomplete.icon ?? /*#__PURE__*/React__default["default"].createElement(IconAdd, {
    ariaLabel: statusConfigs.incomplete.iconLabel ?? ''
  });
  const completeIcon = statusConfigs.complete.icon ?? /*#__PURE__*/React__default["default"].createElement(IconCheckMark, {
    ariaLabel: statusConfigs.complete.iconLabel ?? ''
  });
  return /*#__PURE__*/React__default["default"].createElement(Chip["default"], {
    onClick: onClick
  }, label, isComplete ? completeIcon : incompleteIcon);
};

exports.ActionChip = ActionChip;
exports.ActionChipsContainer = ActionChipsContainer;
